<style scoped>
body {
  min-height: 100vh !important;
}

.btn-primary {
  background-color: #1a3665 !important;
}

.btn-outline-primary {
  border: 1.5px solid #1a3665 !important;
  color: #1a3665 !important;
}

.btn-outline-primary:hover {
  background-color: #1a3665 !important;
  color: white !important;
}

.bg-login-half {
  background-image: url("/img/bg-login.jpg");
  background-size: cover;
}

:root {
  --input-padding-x: 1.5rem;
  --input-padding-y: 0.75rem;
}

.login,
.image {
  min-height: 100vh;
}

.bg-image {
  background-image: url("/img/bg-login.jpg");
  background-size: cover;
  background-position: center;
}

.login-heading {
  font-weight: 300;
}
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .fa {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

/* align icon */
.left-addon .fa {
  left: 0px;
}

.right-addon .fa {
  right: 15px;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}

.right-addon input {
  padding-right: 30px;
}

.errspan {
  float: right;
  margin-right: 12px;
  margin-top: -32px;
  position: relative;
  z-index: 2;
}
/* Fallback for Edge
-------------------------------------------------- */

@supports (-ms-ime-align: auto) {
  .form-label-group > label {
    display: none;
  }

  .form-label-group input::-ms-input-placeholder {
    color: #777;
  }

  span#hidePassword:hover {
    cursor: pointer;
  }
}
</style>
<template>
  <div class="container-fluid bg-white">
    <div class="row no-gutter justify-content-center">
      <div class="col-md-8 col-lg-5">
        <div class="login d-flex align-items-center py-5">
          <div class="container">
            <div class="row">
              <div class="col-md-9 col-lg-8 mx-auto">
                <div class="text-center">
                  <img
                    src="/img/iapi-logo.png"
                    class="img img-fluid img-responsive mb-3"
                    width="80px"
                    alt
                    srcset
                  />
                  <h5 class="font-weight-bold">
                    Institut Akuntan Publik Indonesia
                  </h5>
                  <p class="h6">
                    <i>Indonesia Institute of Certified Public Accountant</i>
                  </p>
                </div>

                <div class="mt-3 mb-n4" v-if="alert == false">
                  <v-alert
                    dismissible
                    type="danger"
                    class="mx-auto alert alert-danger btn-block text-center"
                  >
                    Username dan Password anda tidak sesuai.
                  </v-alert>
                </div>

                <form
                  name="form"
                  v-on:submit.prevent="postLogin"
                  action="#"
                  class="my-xl-5 m-md-3"
                >
                  <label class="font-weight-bold">Username</label>
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control p-4"
                      v-model="user.username"
                      placeholder="Masukkan Username Anda"
                      required
                    />
                  </div>
                    

                  <div class="form-group">
                    <label class="font-weight-bold">Password</label>
                    <div class="input-group mb-3" id="show_hide_password">
                      <input
                        style="border-right: 0px !important"
                        v-model="user.password"
                        :type="typePassword"
                        class="form-control password p-4"
                        placeholder="Masukkan Password Anda"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                      <div class="input-group-append" @click="switchVisibility">
                        <span class="input-group-text bg-white">
                          <i class="fa fa-eye" v-if="typePassword == 'password'"></i>
                          <i class="fa fa-eye-slash" v-else></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="form-group my-1">
                    <div class="custom-control custom-checkbox mr-sm-2">
                      <input type="checkbox" class="custom-control-input" id="check" name="`remember me`" />
                      <label class="custom-control-label font-weight-bold" for="check">Ingat Saya</label>
                    </div>
                  </div> -->
                  <CButton
                    type="submit"
                    color="primary"
                    size="lg"
                    block="true"
                    class="py-2 mt-4 font-weight-bold"
                    >Masuk
                  </CButton>
                  <router-link
                    class="btn btn-lg btn-block btn-outline-primary py-3 mt-3 h6 font-weight-bold"
                    :to="{ name: 'LupaPassword' }"
                  >
                    Lupa Password?
                  </router-link>
                </form>

                <p class="text-center">
                  Copyright © 2020 Institut Akuntan Publik Indonesia <br />
                  All Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-none col-md-4 col-lg-7 bg-image d-sm-none d-lg-block d-xl-block d-md-none"
      >
        <div
          class="d-md-flex align-items-center h-100 text-center justify-content-center ml-auto"
        >
          <div class="col-12 d-flex align-items-center h-100 text-white">
            <div class="ml-auto mt-5">
              <p class="h1 display-4 font-weight-normal text-right">
                Selamat Datang di
              </p>
              <p class="h1 display-4 font-weight-normal text-right">
                Back Office
              </p>
              <h5 class="text-right font-weight-bold">
                Institut Akuntan Publik Indonesia
              </h5>
              <p class="h4 font-weight-normal mt-3 text-right">
                Silakan masuk dengan akun anda.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
import User from "../../models/User";
import baseUrl from "../../services/base-url";
export default {
  name: "Login",
  data() {
    return {
      typePassword: "password",
      classIconPassword: true,
      user: new User("", ""),
      message: "",
      loading: true,
      alert: true,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/dashboard");
    }
  },
  mounted() {
    $(".is-full-page").trigger("click");
    $("#iconHidePassword").on("click", function () {
      alert("sdf");
    });
  },
  methods: {
    switchVisibility() {
      this.typePassword = this.typePassword === 'password' ? 'text' : 'password'
    },
    postLogin() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      var vm = this;
      this.$store.dispatch("auth/login", this.user).then(
        () => {
          loader.hide();
          this.$router.push("/dashboard");
        },
        (error) => {
          loader.hide();
          // comment console console.log(error);
          this.alert = false;
        }
      );
    },
  },
};
</script>